import React, {useEffect, useState} from "react";
import './RegistroVisitantesGraficas.scss';
import HeaderVisitantes from "../../../../components/molecules/HeaderVisitantes/HeaderVisitantes";
import GraficaDeBarras from "../../../../components/organisms/GraficaDeBarras/GraficaDeBarras";
import {Card} from 'primereact/card';
import {Panel} from 'primereact/panel';
import {Calendar} from 'primereact/calendar';
import {Dropdown} from 'primereact/dropdown';
import {Button} from 'primereact/button';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Divider} from 'primereact/divider';
import {Message} from 'primereact/message';
import {ColorValidation, SubmitValidation} from "../../../../utilidades/Validaciones";
import Swal from "sweetalert2";
import {getDataGraficaDeBarrasDia, getDataTableMayor, getDataTableMenor} from "./integracion";

const RegistroVisitantesGraficas = () => {
    const [inputList, setInputList] = useState({
        anio: { value: null, validationType: "empty" },
        semana: { value: null, validationType: "empty" }
    });
    const [dataGraficaDia, setDataGraficaDia] = useState([]);
    const [dataTableMayor, setDataTableMayor] = useState([]);
    const [dataTableMenor, setDataTableMenor] = useState([]);
    const [totalSemana, setTotalSemana] = useState(0);

    // Generar opciones de semanas (1-52)
    const semanasOptions = Array.from({ length: 52 }, (_, i) => ({
        name: `Semana ${i + 1}`,
        code: i + 1
    }));

    useEffect(() => {
        for (const nombrePropiedad in inputList) {
            if (document.getElementById(nombrePropiedad)) {
                ColorValidation(nombrePropiedad, inputList, "empty");
            }
        }
    }, [inputList]);

    useEffect(() => {
        const fecha = new Date();
        const semana = getWeek(fecha);
        const inputListCopy = { ...inputList };
        inputListCopy.semana.value = { name: `Semana ${semana}`, code: semana };
        inputListCopy.anio.value = fecha;
        getDataGraficaDeBarrasDia(setDataGraficaDia, inputListCopy.anio.value.getFullYear(), inputListCopy.semana.value.code, setTotalSemana);
        setInputList(inputListCopy);
        getDataTableMayor(setDataTableMayor, inputListCopy.semana.value.code, inputListCopy.anio.value.getFullYear());
        getDataTableMenor(setDataTableMenor, inputListCopy.semana.value.code, inputListCopy.anio.value.getFullYear());
    }, []);

    function getWeek(date) {
        const copiedDate = new Date(date.getTime());
        copiedDate.setHours(0, 0, 0, 0);
        copiedDate.setDate(copiedDate.getDate() + 4 - (copiedDate.getDay() || 7));
        const yearStart = new Date(copiedDate.getFullYear(), 0, 1);
        return Math.ceil((((copiedDate - yearStart) / 86400000) + 1) / 7);
    }

    const cambiarAnio = (e) => {
        const copiaLista = { ...inputList };
        copiaLista.anio.value = e.value;
        setInputList(copiaLista);
    };

    const cambiarSemana = (e) => {
        const copiaLista = { ...inputList };
        copiaLista.semana.value = e.value;
        setInputList(copiaLista);
    };

    const filtrarGraficaSemanas = () => {
        if (SubmitValidation(inputList, setInputList)) {
            getDataGraficaDeBarrasDia(setDataGraficaDia, inputList.anio.value.getFullYear(), inputList.semana.value.code, setTotalSemana);
            getDataTableMayor(setDataTableMayor, inputList.semana.value.code, inputList.anio.value.getFullYear());
            getDataTableMenor(setDataTableMenor, inputList.semana.value.code, inputList.anio.value.getFullYear());
        } else {
            Swal.fire({
                icon: "error",
                title: "Complete todos los campos solicitados",
                showConfirmButton: false,
                timer: 1500
            });
        }
    };

    const diasSemana = [
        { label: 'Lunes', index: 3, color: 'blue' },
        { label: 'Martes', index: 4, color: 'indigo' },
        { label: 'Miércoles', index: 0, color: 'purple' },
        { label: 'Jueves', index: 1, color: 'pink' },
        { label: 'Viernes', index: 2, color: 'teal' }
    ];

    return (
        <div className="RegistroVisitantesGraficas">
            <HeaderVisitantes seccion={"3"} />

            <div className="p-fluid">
                <Card className="filtros-card">
                    <div className="card-title">
                        <i className="pi pi-chart-line"></i>
                        <h2>Visualizar visitas por semana</h2>
                    </div>

                    <Message
                        severity="info"
                        text="Seleccione el año y la semana para ver los reportes"
                        className="mb-3"
                    />

                    <div className="grid">
                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="anio" className="field-label">
                                    Año <span className="required">*</span>
                                </label>
                                <Calendar
                                    id="anio"
                                    value={inputList.anio.value}
                                    onChange={cambiarAnio}
                                    view="year"
                                    dateFormat="yy"
                                    placeholder="Seleccione el año"
                                    showIcon
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="semana" className="field-label">
                                    Semana <span className="required">*</span>
                                </label>
                                <Dropdown
                                    id="semana"
                                    optionLabel="name"
                                    value={inputList.semana.value}
                                    options={semanasOptions}
                                    onChange={cambiarSemana}
                                    placeholder="Seleccione la semana"
                                    filter
                                    filterPlaceholder="Buscar semana..."
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-content-center mt-3">
                        <Button
                            label="Filtrar Datos"
                            icon="pi pi-filter"
                            onClick={filtrarGraficaSemanas}
                            className="filter-button"
                            size="large"
                        />
                    </div>
                </Card>

                {dataGraficaDia.length > 0 && (
                    <>
                        <Card className="grafica-card mt-3">
                            <div className="section-title">
                                <i className="pi pi-chart-bar"></i>
                                Gráfica de visitas
                            </div>
                            <div className="grafica-contenedor">
                                <GraficaDeBarras data={dataGraficaDia} />
                            </div>
                        </Card>

                        <Card className="totales-card mt-3">
                            <div className="section-title mb-3">
                                <i className="pi pi-calendar"></i>
                                Total de visitas por día
                            </div>

                            <div className="grid">
                                {diasSemana.map((dia) => (
                                    <div key={dia.label} className="col-12 md:col-6 lg:col">
                                        <Panel
                                            header={dia.label}
                                            className={`dia-panel dia-${dia.color}`}
                                        >
                                            <div className="total-visitas">
                                                <i className="pi pi-users"></i>
                                                <span className="numero">
                                                    {dataGraficaDia[dia.index]?.Total_Visitas || 0}
                                                </span>
                                                <span className="label">visitas</span>
                                            </div>
                                        </Panel>
                                    </div>
                                ))}
                            </div>

                            <Divider />

                            <Panel header="Total Semanal" className="total-semana-panel">
                                <div className="total-semana-content">
                                    <i className="pi pi-chart-pie"></i>
                                    <span className="total-numero">{totalSemana}</span>
                                    <span className="total-label">visitas en la semana</span>
                                </div>
                            </Panel>
                        </Card>
                    </>
                )}

                <Card className="tabla-card mt-3">
                    <div className="section-title mb-3">
                        <i className="pi pi-clock"></i>
                        Tiempo mayor por visita
                    </div>
                    <DataTable
                        value={dataTableMayor}
                        emptyMessage="No hay datos disponibles"
                        stripedRows
                        paginator={dataTableMayor.length > 10}
                        rows={10}
                        className="custom-datatable"
                    >
                        <Column
                            field="tiempo"
                            header="Tiempo (h/m)"
                            sortable
                            style={{ minWidth: '120px' }}
                        />
                        <Column
                            field="departamento"
                            header="Departamento"
                            sortable
                            style={{ minWidth: '150px' }}
                        />
                        <Column
                            field="unidad"
                            header="Unidad"
                            sortable
                            style={{ minWidth: '120px' }}
                        />
                        <Column
                            field="motivo"
                            header="Motivo"
                            sortable
                            style={{ minWidth: '200px' }}
                        />
                    </DataTable>
                </Card>

                <Card className="tabla-card mt-3">
                    <div className="section-title mb-3">
                        <i className="pi pi-stopwatch"></i>
                        Tiempo menor por visita
                    </div>
                    <DataTable
                        value={dataTableMenor}
                        emptyMessage="No hay datos disponibles"
                        stripedRows
                        paginator={dataTableMenor.length > 10}
                        rows={10}
                        className="custom-datatable"
                    >
                        <Column
                            field="tiempo"
                            header="Tiempo (h/m)"
                            sortable
                            style={{ minWidth: '120px' }}
                        />
                        <Column
                            field="departamento"
                            header="Departamento"
                            sortable
                            style={{ minWidth: '150px' }}
                        />
                        <Column
                            field="unidad"
                            header="Unidad"
                            sortable
                            style={{ minWidth: '120px' }}
                        />
                        <Column
                            field="motivo"
                            header="Motivo"
                            sortable
                            style={{ minWidth: '200px' }}
                        />
                    </DataTable>
                </Card>
            </div>
        </div>
    );
};

export default RegistroVisitantesGraficas;
